import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { sendRequest, returnRequest } from '../redux/http-status/http-status.actions';

@Injectable({ providedIn: 'root' })
export class HttpStatusInterceptor implements HttpInterceptor {
  private store = inject(Store);

  
 

  

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.store.dispatch(sendRequest());

    let cancelled = true;
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          this.store.dispatch(returnRequest());
          cancelled = false;
        }

        return event;
      }),
      catchError(error => {
        this.store.dispatch(returnRequest());
        cancelled = false;

        return throwError(error);
      }),
      finalize(() => {
        if (cancelled) {
          this.store.dispatch(returnRequest());
        }
      }),
    );
  }
}
